'use client';
import { Box, Container, Heading, SimpleGrid, Text } from '@chakra-ui/react';

import CustomImage from '@/app/_components/custom-image/CustomImage';
import LinkCustom from '@/app/_components/link/LinkCustom';
import { getImageLink } from '@/services/link.service';
import { ImageTransformationKeys } from '@/types/files/files.types';
import { CallToAction } from '@/types/home/home.types';

import Styles from './RequestQuote.module.scss';

type Props = {
  call_to_actions: CallToAction;
};

const imageKey: ImageTransformationKeys = {
  mobileKey: 'image-420-180',
  desktopKey: 'image-750-380',
};

const RequestQuote = ({ call_to_actions }: Props) => {
  return (
    <Box className={Styles.requestQuoteSection}>
      <Container
        maxWidth={{ base: '100%', md: '1160px' }}
        alignContent={'center'}
        paddingX={{ base: '24px', lg: '0' }}
        paddingY={'56px'}
      >
        <SimpleGrid
          gridTemplateColumns={{ md: '390px 1fr', lg: '467px 1fr' }}
          columns={{ base: 1, md: 2 }}
          alignItems={{ base: 'flex-start', md: 'center' }}
          paddingLeft={{ lg: '30px', xl: '0' }}
        >
          <Box marginBottom={{ base: 8, md: 0 }} order={{ base: 1, md: 2 }}>
            <CustomImage
              imageKeys={imageKey}
              imageSrc={getImageLink(call_to_actions?.image) ?? ''}
              alt={call_to_actions?.text ?? 'Finance car'}
              width={693}
              height={377}
              className={Styles.requestQuoteImg}
            />
          </Box>
          <Box className={Styles.headingElement} order={{ base: 2, md: 1 }}>
            <Heading
              as="h3"
              className={Styles.titleLg}
              marginBottom={{ base: 4, md: 5 }}
            >
              {call_to_actions?.heading}
            </Heading>
            <Text
              className={Styles.titleText}
              marginBottom={{ base: 5, md: 6 }}
            >
              {call_to_actions?.subheading}
            </Text>
            <LinkCustom href="" className="btnOutline">
              Get started
            </LinkCustom>
          </Box>
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default RequestQuote;
